import {makeStyles} from '@mui/styles'

const useBannerStyles = makeStyles({
  surface: {
    background:
      'radial-gradient(ellipse 200px 90px at 103% 0%, rgba(255, 152, 16, 0.2), transparent 75%), radial-gradient(ellipse 230px 120px at 103% 100%, rgba(219, 0, 37, 0.22), transparent 80%), #ffffff',
  },
  link: {
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    gap: 24,
    width: '100%',
    height: 42,
    padding: '0 36px 0 0',
    color: '#1b1d26',
    textDecoration: 'none',
    fontFamily: 'CamptonLight, Montserrat, sans-serif',
    lineHeight: 1.25,
    '&:hover': {color: '#1b1d26', textDecoration: 'none'},
    '&:focus-visible': {outline: '2px solid #003189', outlineOffset: -2},
    '&:hover $cta': {background: '#343744'},
  },
  // Only the SVG illustration area is shown; text and CTA remain live HTML.
  artwork: {
    position: 'relative',
    flex: '0 0 219px',
    height: 42,
    overflow: 'hidden',
    '& img': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: 903,
      maxWidth: 'none',
      height: 42,
    },
  },
  copy: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    gap: 24,
    minWidth: 0,
  },
  title: {
    fontSize: 15,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    fontFamily: 'CamptonSemiBold, Montserrat, sans-serif',
    fontWeight: 700,
  },
  description: {color: '#55555d', fontSize: 15},
  cta: {
    flexShrink: 0,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    minHeight: 34,
    padding: '6px 20px',
    borderRadius: 999,
    background: '#1b1d26',
    color: '#ffffff',
    fontSize: 15,
    boxShadow: '0 2px 5px rgba(27, 29, 38, 0.18)',
    fontFamily: 'CamptonSemiBold, Montserrat, sans-serif',
    textAlign: 'center',
    transition: 'background-color 160ms ease',
  },
  '@media (max-width: 1100px)': {
    link: {gap: 20, padding: '0 20px'},
    artwork: {flexBasis: 50, '& img': {left: -169}},
  },
  '@media (max-width: 900px)': {description: {display: 'none'}},
  '@media (max-width: 600px)': {
    link: {gap: 10, padding: '0 12px'},
    artwork: {
      flexBasis: 40,
      height: 36,
      '& img': {width: 774, height: 36, left: -145},
    },
    title: {fontSize: 12, lineHeight: 1.1, flexShrink: 1, whiteSpace: 'normal'},
    cta: {
      boxSizing: 'border-box',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      maxWidth: 112,
      minHeight: 34,
      padding: '2px 10px',
      fontSize: 13,
    },
  },
})

export default useBannerStyles
